import { StundenbewertungInputBlock } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/Stundenbewertung/StundenbewertungInputBlock';
import { StundenbewertungToggle } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/Stundenbewertung/StundenbwertungToggle';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function StundenbewertungBlock() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();

  const {
    bezahlungsart: { art },
    arbeitszeitkonto: {
      arbeitstage,
      gehaltsempfaenger: { stundenpensum },
    },
  } = form.state.values.bezahlung;

  const arbeitstageSelected = arbeitstage.length > 0;
  const onlyFesteStundenbewertung =
    (arbeitstageSelected && art === 'fixgehalt') ||
    (art === 'fixgehalt' && stundenpensum === 'woche');

  // muss über useEffect gesetzt werden weil das Field in diesem Fall nicht gerendert wird
  useEffect(() => {
    if (onlyFesteStundenbewertung) {
      form.setFieldValue('abwesenheiten.allgemein.stundenBewertung', 'fest');
      ctx.resetDependentFields('abwesenheiten.allgemein.dynamisch');
    }
  }, [onlyFesteStundenbewertung, form, ctx]);

  return (
    <div className="flex flex-col gap-6">
      {!onlyFesteStundenbewertung && (
        <>
          <div className="flex flex-col gap-3">
            <h2 className="text-neutrals-900 text-xl font-bold leading-7">
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.title',
              )}
            </h2>
            <span className="text-neutrals-800 text-sm font-normal leading-5">
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.description',
              )}
            </span>
          </div>
          <StundenbewertungToggle
            onlyFesteStundenbewertung={onlyFesteStundenbewertung}
          />
        </>
      )}
      <StundenbewertungInputBlock />
    </div>
  );
}
